import React, {useState} from 'react';
import {format} from 'date-fns';

import Avatar from 'components/Avatar';
import Button from 'components/Button';

import useCurrentUser from 'hooks/useCurrentUser';
import useNow from 'hooks/useNow';
import {getFullName} from 'helpers/user';

import styles from './NoteForm.module.scss';

interface Props {
  onSubmit: (text: string, driver: boolean) => any;
  isCompleted: boolean;
}

function NoteForm({onSubmit, isCompleted}: Props) {
  const currentUser = useCurrentUser();
  const [text, setText] = useState('');
  const [visibleDriver, setVisibleDriver] = useState(false);
  const now = useNow();

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (
    event
  ) => {
    setText(event.currentTarget.value);
  };

  const handleSubmit = async () => {
    onSubmit(text, visibleDriver);

    setText('');
  };

  return (
    <div className={styles.root}>
      <Avatar name={getFullName(currentUser)} file={currentUser?.avatar} />
      <div className={styles.content}>
        <textarea
          placeholder="Write a note"
          className={styles.textarea}
          value={text}
          onChange={handleChange}
        />
        <div className={styles.bottom}>
          <div className={styles.datetime}>
            {/* <ClockIcon className={styles.clock_icon} /> */}
            {format(now, 'MMM d, yyyy h:mm aa')}
          </div>

          {!isCompleted && (
            <div className={styles.checkbox}>
              <input
                checked={visibleDriver}
                onChange={() => {
                  setVisibleDriver(!visibleDriver);
                }}
                type="checkbox"
              />
              Show note in Jobs App
            </div>
          )}
          <Button className={styles.button} size="lg" onClick={handleSubmit}>
            Post
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NoteForm;
